export default class extends HTMLElement {
  connectedCallback () {
    const raw = this.dataset.url

    if (!raw) {
      return
    }

    let url

    try {
      url = new URL(raw, document.location.origin)
    } catch (e) {
      return
    }

    url.protocol = document.location.protocol
    url.host = document.location.host

    const href = url.toString()

    const input = this.querySelector('input')

    if (input) {
      input.value = href
    }

    const copyEl = this.querySelector('clipboard-copy')

    if (copyEl) {
      copyEl.dataset.text = href
    }
  }
}
